import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { InputType } from '../../../../common/components/form-builder/form-builder.component';
import { RequestButtonTypes } from '../../../../common/components/request-button/request-button.component';
import { StorageManager } from '../../../../common/storage-manager.class';
import { createCsv } from '../../../../common/createCsv';
import { Utils } from '../../../../common/utils';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { Filtering } from 'src/app/service/filtering/filtering';
import { AppFormRequest } from 'src/app/view/app-common/form-request/app-form-request';
import { BaseView } from 'src/app/view/base-view';
import { environment } from 'src/environments/environment';

import { ItemInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { AgroambientalModel } from 'src/app/models/tareas/agroambientales.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-agroambientales',
    standalone: false,
    templateUrl: './agroambientales.component.html',
    styleUrls: ['./agroambientales.component.scss']
})
export class AgroambientalesComponent extends BaseView<AgroambientalModel>  {

    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;
    
    public appName = environment.appName;
    
    public applicationType = environment.features.applicationType;
    
    public rolUser = StorageManager.getUser().rol;
    
    public userCanSeeClientes = environment.features.userCanSeeClientes;

    public getRequest = this.tareasApi.agroambientales.GET;

    public deleteRequest = this.tareasApi.agroambientales.DELETE;

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;  

    public filter: Filtering<AgroambientalModel> = new Filtering<AgroambientalModel>();

    public fincaName = environment.features.fincaName;

    public sectorName = environment.features.sectorName;

    public parcelaName = environment.features.parcelaName;

    public pathToForm = 'tareas-crear-agroambiental';

    public pathToEdit = 'tareas-editar-agroambiental';
    
    public pathToDuplicate = 'tareas-duplicar-agroambiental';

    public formRequest = new AppFormRequest<AgroambientalModel>();

    public override canShow: Record<string, boolean> = {};
    
    public override model: AgroambientalModel = {};

    typesEcorregimen: string[] = [
        'Leñosos',
        'Pastoreo',
        'Arroz',
    ];

    public cols: ColInterface[] = [
        { field: 'finca', header: this.fincaName },
        { field: 'sector', header: this.sectorName },
        { field: 'parcelas', header: this.parcelaName },
        { field: 'fecha_establecimiento_cv', header: 'F. Establecimiento C. Vegetal' },
        { field: 'nombre_mantenimiento', header: 'Tipo Mantenimiento C. Vegetal' },
        { field: 'anchura_cv', header: 'Anchura C. Vegetal' },
        { field: 'anchura_libre_proyeccion_1', header: 'Anchura Libre Proyección V.' },
        { field: 'fecha_establecimiento_ci', header: 'F. Establecimiento C. Inerte' },
        { field: 'anchura_ci', header: 'Tipo Mantenimiento C. Inerte' },
        { field: 'anchura_libre_proyeccion_2', header: 'Anchura Libre Proyección I.' },
    ];

    colsAva: ColInterface[] = [
        { field: 'finca', header: this.fincaName },
        { field: 'sector', header: this.sectorName },
        { field: 'parcelas', header: this.parcelaName },
        { field: 'tipo_ecorregimen', header: 'Tipo Ecorrégimen' },
        { field: 'fecha_seca_inicio_intermitente', header: 'Fecha Inicio Seca'},
        { field: 'fecha_seca_fin_intermitente', header: 'Fecha Fin Seca'},
    ];

    public formFieldsPlaces: ItemInterface<object>[] = [
        { 
            field: 'finca', 
            label: 'Finca', 
            inputType: {type: InputType.TEXT }, 
        },
        { 
            field: 'sector',
            label: 'Sector',
            inputType: { type: InputType.TEXT },
        },
        { 
            field: 'parcelas', 
            label: this.parcelaName, 
            inputType: {type: InputType.TEXT },
        }
    ];

    public formFields: ItemInterface<object>[] = [
        { 
            field: 'fecha_establecimiento_cv', 
            name: 'Fecha Establecimiento Cubierta Vegetal', 
            label: 'Fecha Establecimiento Cubierta Vegetal', 
            inputType: { type: InputType.TEXT } 
        },
        { 
            field: 'anchura_cv', 
            name: 'Anchura Cubierta Vegetal (m)', 
            label: 'Anchura Cubierta Vegetal (m)', 
            inputType: { type: InputType.TEXT } 
        },
        { 
            field: 'nombre_mantenimiento', 
            name: 'Tipo Mantenimiento Cubierta Vegetal', 
            label: 'Tipo Mantenimiento Cubierta Vegetal', 
            inputType: { type: InputType.TEXT } 
        },
        {
            field: 'anchura_libre_proyeccion_1',
            name: 'Anchura Libre Proyeccion Copa (m)',
            label: 'Anchura Libre Proyeccion Copa (m)',
            inputType: { type: InputType.TEXT } 
        },

    ];

    public formFieldsCubiertasInertes: ItemInterface<object>[] = [
        { 
            field: 'fecha_establecimiento_ci', 
            name: 'Fecha Establecimiento Cubierta Inerte', 
            label: 'Fecha Establecimiento Cubierta Inerte', 
            inputType: { type: InputType.TEXT } 
        },
        { 
            field: 'anchura_ci', 
            name: 'Anchura Cubierta Inerte (m)',
            label: 'Anchura Cubierta Inerte (m)', 
            inputType: { type: InputType.TEXT } 
        },
        { 
            field: '', 
            label: '', 
            inputType: { type: InputType.EMPTY } 
        },
        { 
            field: 'anchura_libre_proyeccion_2',
            name: 'Anchura libre de la Proyección Copa (m)', 
            label: 'Anchura libre de la Proyección Copa (m)', 
            inputType: { type: InputType.TEXT } 
        },
    ];

    public formFieldsArroz: ItemInterface<object>[] = [
        { field: 'fecha_arroz', label: 'Fecha Arroz', inputType: { type: InputType.TEXT } },
        { field: 'labor', label: 'Labor', inputType: { type: InputType.TEXT } },
        { field: 'tipo_operacion', label: 'Tipo Operación', inputType: { type: InputType.TEXT } },
        { field: 'id_maquinaria', label: 'Maquinaria', inputType: { type: InputType.TEXT } },
        { field: 'observaciones', label: 'Observaciones', inputType: { type: InputType.TEXTAREA } },
    ];

    formFieldsArroz2: ItemInterface<object>[] = [
        { field: 'fecha_inicio_inundacion_cultivo', label: 'Fecha Inicio Inundación Cultivo', inputType: { type: InputType.TEXT } },
        { field: 'fecha_fin_inundacion_cultivo', label: 'Fecha Fin Inundación Cultivo', inputType: { type: InputType.TEXT } },
        { field: 'fecha_inicio_inundacion_invernal', label: 'Fecha Inicio Inundación Invernal', inputType: { type: InputType.TEXT } },
        { field: 'fecha_fin_inundacion_invernal', label: 'Fecha Fin Inundación Invernal', inputType: { type: InputType.TEXT } },
        { field: 'fecha_seca_inicio_intermitente', label: 'Fecha Inicio Seca Intermitente', inputType: { type: InputType.TEXT } },
        { field: 'fecha_seca_fin_intermitente', label: 'Fecha Fin Seca Intermitente', inputType: { type: InputType.TEXT } }
    ];

    formFieldsPastoreoExtensivo: ItemInterface<Object>[] = [
        {
            field: 'fecha_inicio_pastoreo_extensivo',
            label: 'Fecha Inicio Pastoreo Extensivo',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_fin_pastoreo_extensivo',
            label: 'Fecha Fin Pastoreo Extensivo',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'nombre_especie',
            label: 'Especie',
            inputType: { type: InputType.TEXT },
        },
        {
            field: 'rega',
            label: 'REGA',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'numero_animales',
            label: 'Número de Animales',
            inputType: { type: InputType.TEXT }
        }
    ];

    formFieldsPastoreo: ItemInterface<object>[] = [
        {
            field: 'fecha_inicio_pastoreo_extensivo',
            label: 'Fecha Inicio Pastoreo Extensivo',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_fin_pastoreo_extensivo',
            label: 'Fecha Fin Pastoreo Extensivo',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'nombre_especie',
            label: 'Especie',
            inputType: { type: InputType.TEXT },
        },
        {
            field: 'rega',
            label: 'REGA',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'numero_animales',
            label: 'Número de Animales',
            inputType: { type: InputType.TEXT }
        }
    ];

    formFieldsPastoreoIslasBiodiversidad: ItemInterface<Object>[] = [
        {
            field: 'fecha_siega_1',
            label: 'Siega: 1er Fecha Corte',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_siega_2',
            label: 'Siega: 2do Fecha Corte',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_siega_3',
            label: 'Siega: 3er Fecha Corte',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_laboreo',
            label: 'Fecha Laboreo',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'fecha_siembra',
            label: this.appName === 'avafitogest' ? 'Fecha Mantenimiento' : 'Fecha Siembra',
            inputType: { type: InputType.TEXT }
        },
        {
            field: 'otras_actividades',
            label: this.appName === 'avafitogest' ? 'Observaciones Mantenimiento' : 'Otras Actividades',
            inputType: { type: InputType.TEXT }
        }
    ];

    constructor(
        dashboard: DashboardService,
        private readonly router: Router,
        private readonly tareasApi: TareasApiService
    ) {
        super(
            dashboard,
            tareasApi.agroambientales.GET,
            tareasApi.agroambientales.DELETE
        );
    }

    public add() {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: AgroambientalModel) {
        this.router.navigate(['dashboard', this.pathToEdit, data.id]);
    }

    public duplicate(data: AgroambientalModel) {
        this.router.navigate(['dashboard', this.pathToDuplicate, data.id]);
    }

    public override hide(modal: string): void {
        this.model = {};
        console.log(modal);
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return {textAlign: 'center'};
    }
  
    public downloadCsv(): void {
  
        const arrayFormFields = [
            this.formFields,
            this.formFieldsCubiertasInertes
        ];
  
        const csvContent = createCsv(arrayFormFields, this.filter.value, 'anchura_libre_proyeccion_2');
  
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = 'Tareas Agroambientales.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<AgroambientalModel>) {
        const agroambiental = row.data as AgroambientalModel;

        if (Utils.isNumber(value) && col.field !== 'finca') {
            // formato decimal y millar
            return Utils.decimalFormat(value, 2, '.', ',', 3);
        }
        
        if (col.field === 'parcelas') {
            const str = Utils.replaceAll(Utils.replaceAll((agroambiental[col.field]?.toString() || ''), '- ', ''), '\n', '\n, ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        // Validar formato de fecha para campos de seca intermitente
        if (col.field === 'fecha_seca_inicio_intermitente' || col.field === 'fecha_seca_fin_intermitente') {
            if (!value) {
                return '';
            }
            
            // Verificar si la fecha tiene formato incorrecto (YYYY-MM-DD o contiene NaN)
            const invalidFormats = [
                /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                /NaN/i // Contiene NaN en cualquier formato
            ];
            
            const isInvalidFormat = invalidFormats.some(pattern => pattern.test(value));
            
            if (isInvalidFormat) {
                return '';
            }
            
            // Validar formato correcto DD/MM/YYYY
            const validDatePattern = /^\d{2}\/\d{2}\/\d{4}$/;
            if (!validDatePattern.test(value)) {
                return '';
            }
        }

        return value;
    }
}